// A fancyful typography demo page; props and credits to,
// https://roobinium.io/, for a beatiful and easy to use design. 
import { DemoHeader, DemoInfoBox } from '@/components/demo';
import { 
    TitleLarge,
    TitleMedium,
    BodyLarge,
    BodyXLBold,
    BodyXLMedium,
    BodyXLMediumRelaxed,
    BodyBold,
    BodyMedium,
    BodyRegular,
    BodySmallMedium,
    BodySmallRegular,
} from '@/components/typography';

export const TypographyDemo = () => {
    return (
        <div className="min-h-screen p-12">
            <div className="max-w-6xl mx-auto space-y-16">
                <DemoHeader badge="#styles" title="fonts" />

                <DemoInfoBox 
                    description={
                        <>
                            Typography styles are accessed as <span className="text-primary font-bold">React components</span>, not Tailwind classes. 
                            Import and use them directly in your JSX with <code className="px-2 py-1 bg-base-300 rounded text-sm">children</code> props.
                        </>
                    }
                    example="<TitleLarge>Hello World</TitleLarge>"
                />

                {/* Title Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">01_title</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">2 styles</p>
                    </div>
                    <div className="space-y-6">
                        <div className="flex justify-between items-center">
                            <div>
                                <TitleLarge>TitleLarge</TitleLarge>
                                <BodySmallRegular>Outfit Bold_68</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-[68px] font-bold leading-[72px]">lh 72</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <TitleMedium>TitleMedium</TitleMedium>
                                <BodySmallRegular>Outfit Bold_40</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-[40px] font-bold leading-[48px]">lh 48</span>
                        </div>
                    </div>
                </div>

                {/* Body Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">02_body</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">9 styles</p>
                    </div>
                    <div className="space-y-6">
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyLarge>BodyLarge</BodyLarge>
                                <BodySmallRegular>Outfit Bold_56</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-[56px] font-bold leading-[60px]">lh 60</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyXLBold>BodyXLBold</BodyXLBold>
                                <BodySmallRegular>Outfit ExtraBold_20</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-xl font-extrabold leading-6">lh 24</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyXLMedium>BodyXLMedium</BodyXLMedium>
                                <BodySmallRegular>Outfit Medium_20</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-xl font-medium leading-6">lh 24</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyXLMediumRelaxed>BodyXLMediumRelaxed</BodyXLMediumRelaxed>
                                <BodySmallRegular>Outfit Medium_20</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-xl font-medium leading-8">lh 32</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyBold>BodyBold</BodyBold>
                                <BodySmallRegular>Outfit Bold_16</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-base font-bold leading-6">lh 24</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyMedium>BodyMedium</BodyMedium>
                                <BodySmallRegular>Outfit Medium_16</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-base font-medium leading-6">lh 24</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodyRegular>BodyRegular</BodyRegular>
                                <BodySmallRegular>Outfit Regular_16</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-base font-normal leading-6">lh 24</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodySmallMedium>BodySmallMedium</BodySmallMedium>
                                <BodySmallRegular>Outfit Medium_14</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-sm font-medium leading-5">lh 20</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <div>
                                <BodySmallRegular>BodySmallRegular</BodySmallRegular>
                                <BodySmallRegular>Outfit Regular_14</BodySmallRegular>
                            </div>
                            <span className="font-outfit text-sm font-normal leading-5">lh 20</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};